import React from "react";
import { Layout } from "antd";

const { Footer: AppFooter } = Layout

const contactInfo = {
  mail: {
    text: "rohan@usemeru.com",
    link: "mailto:rohan@usemeru.com",
    label: "Email"
  },
  phone: {
    text: "(510)-894-5410",
    link: "tel:+15108945410",
    label: "Phone"
  }
}

const Footer = () => {
  return (
    <AppFooter className="bg-gray-900 text-gray-300 flex justify-between items-center p-6">
      <div className="flex flex-col">
        <div className="flex items-center mb-2">
          <img src="/logo_meru_white.svg" alt="Logo" className="h-8 mr-2" />
        </div>
        <p className="text-gray-400">© 2024 Meru Productions Inc, All rights reserved.</p>
      </div>

      <div className="text-right max-w-xs">
        {Object.values(contactInfo).map(val =>
          <p>{val.label}: <a href={val.link} className="text-gray-300">{val.text}</a></p>
        )}
        <p className="mt-2 text-gray-400">
          Meru is founded in San Francisco. We're backed by YCombinator and Cadenza Ventures.
        </p>
      </div>
    </AppFooter>
  );
};

export default Footer;